// Dynamic observer of the current language
import { useEffect, useState } from "react";
import { getPreferredLanguage } from "../utils/languageUtils";

export default function useCurrentLanguage(): string {
    const [lang, setLang] = useState(getPreferredLanguage());

    useEffect(() => {
        if (!window.Weglot) return;

        const observer = new MutationObserver(() => {
            setLang(getPreferredLanguage());
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["lang"],
        });

        return () => observer.disconnect();
    }, []);

    return lang;
}
